const shortSummary =
  "Software engineer with expertise building .NET microservices, cloud platforms (Azure/AWS), and scalable backend systems.";

const summary = `${shortSummary} Passionate about building resilient, cloud-native applications and solving complex technical challenges. Committed to continuous improvement and delivering impactful, high-quality software for forward-thinking teams.`;

const areasOfInterest =
  "Currently focused on backend system design, distributed and event-driven architectures, and infrastructure as code (Terraform). I’m also interested in developer tooling and workflows, including the practical use of AI-assisted development tools such as Claude Code to improve productivity.";

export { shortSummary, summary, areasOfInterest };
